import {
  Box,
  Typography,
  Button,
  Stack,
  Chip,
  Paper,
  Grid,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { host } from "../constant/backendpath";
import thiran_banner from "../assets/img/thiran_banner.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GroupsIcon from "@mui/icons-material/Groups";
import EmailIcon from "@mui/icons-material/Email";
import Avatar from "@mui/material/Avatar";
import PhoneIcon from "@mui/icons-material/Phone";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import Alert from "../widgets/AlertModal";

function ProjectDetails({ project, profile, onBack, fetch }) {
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const [closeable, setCloseable] = useState(false);
  const [goBackAfterClose, setGoBackAfterClose] = useState(false);

  const confirmDeleteMember = (teamId, reg_no) => {
    setPendingDelete({ teamId, reg_no });

    setAlertMessage("Are you sure you want to remove this member?");
    setAlertType("warning");
    setCloseable(true);
    setOpen(true);
  };

  const handleDeleteMember = async () => {
    try {
      const { teamId, reg_no } = pendingDelete;

      const res = await axios.delete(`${host}team/member/${teamId}/${reg_no}`);

      if (res.status === 200) {
        // Call the fetch function to refresh the project details
        setAlertMessage("Member removed successfully");
        setAlertType("success");
        setCloseable(false);
        setGoBackAfterClose(true);
        setOpen(true);
        fetch();
      }
    } catch (err) {
      setAlertMessage("Failed to remove member");
      setAlertType("error");
      setCloseable(false);
      setOpen(true);
    }

    setPendingDelete(null);
  };
  // console.log(project);
  return (
    <>
      <Alert
        open={open}
        setOpen={setOpen}
        message={alertMessage}
        type={alertType}
        onOk={() => {
          if (alertType === "warning") {
            handleDeleteMember();
          } else if (goBackAfterClose) {
            onBack();
          }
        }}
        closeable={closeable}
      />
      <Box
        sx={{
          position: "relative",
          height: {
            xs: 280,
            md: 380,
          },
          borderRadius: 3,
          overflow: "hidden",
          mb: 3,
        }}
      >
        {/* Banner Image */}

        <Box
          component="img"
          src={thiran_banner}
          alt={"Project Banner"}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "fill",
          }}
        />

        {/* Dark Overlay */}

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.2))",
          }}
        />

        {/* Content */}

        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            p: {
              xs: 2,
              md: 4,
            },
          }}
        >
          {/* Back Button */}

          <Button
            startIcon={<ArrowBackIcon />}
            sx={{
              color: "#fff",
              mb: 2,
              textTransform: "none",
            }}
            onClick={onBack}
          >
            Back to Projects
          </Button>

          {/* Status */}

          <Chip
            label={project.status}
            color="success"
            size="small"
            sx={{
              mb: 2,
              fontWeight: 600,
            }}
          />

          {/* Title */}

          <Typography
            variant="h3"
            sx={{
              color: "#fff",
              fontWeight: 700,
              mb: 1,
              fontSize: {
                xs: "1.8rem",
                md: "2.7rem",
              },
            }}
          >
            {project.teamTitle || "-"}
          </Typography>

          {/* Subtitle */}

          <Typography
            sx={{
              color: "rgba(255,255,255,0.8)",
              maxWidth: "700px",
              mb: 3,
            }}
          >
            {project.teamdes || "-"}
          </Typography>

          {/* Buttons */}

          <Stack direction="row" spacing={2} flexWrap="wrap">
            <Button
              variant="outlined"
              startIcon={<GitHubIcon />}
              href={project.github || "#"}
              sx={{
                color: "#fff",
                borderColor: "rgba(255,255,255,0.4)",

                "&:hover": {
                  borderColor: "#fff",
                },
              }}
            >
              GitHub
            </Button>

            <Button
              variant="contained"
              startIcon={<LaunchIcon />}
              href={project.demo || "#"}
            >
              Live Demo
            </Button>
          </Stack>
        </Box>
      </Box>
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 3,
          borderRadius: 3,
          padding: 3,
          m: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Grid container spacing={3} gap={3}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
              }}
            >
              <PeopleAltIcon color="primary" />

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Team
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  {project.teamName || "-"}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
              }}
            >
              <SchoolIcon color="primary" />

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Domain
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  {project.department || "-"}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
              }}
            >
              <PersonIcon color="primary" />

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Mentor
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  {project.mentor || "-"}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 3,
              }}
            >
              <CalendarMonthIcon color="primary" />

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Started
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  {project.date || "10-02-2007"}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={3} p={2}>
        <Grid item xs={12} md={8} lg={9}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 2,
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                ml: 1,
              }}
            >
              <DescriptionOutlinedIcon color="primary" />

              <Typography variant="h6" fontWeight={600}>
                Abstract
              </Typography>
            </Box>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.9,
                textAlign: "justify",
                fontSize: "0.95rem",
              }}
            >
              {project.abstract || "No abstract available."}
            </Typography>
          </Paper>
          {/* <Paper
  elevation={0}
  sx={{
    p: 3,
    mb: 3,
    borderRadius: 3,
    border: "1px solid",
    borderColor: "divider",
  }}
>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      mb: 3,
    }}
  >
    <TrackChangesIcon color="primary" />

    <Typography
      variant="h6"
      fontWeight={600}
    >
      Objectives
    </Typography>
  </Box>

  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        md: "repeat(2,1fr)",
      },
      gap: 2,
    }}
  >
    {(project.objective || []).map(
      (objective, index) => (
        <Paper
          key={index}
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            display: "flex",
            gap: 1.5,
            alignItems: "flex-start",
            bgcolor: "#fafafa",
          }}
        >
          <CheckCircleOutlineIcon
            color="success"
            sx={{
              mt: "2px",
              fontSize: 20,
            }}
          />

          <Box>
            <Typography
              fontWeight={600}
              fontSize="0.85rem"
            >
              Objective {index + 1}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
            >
              {objective}
            </Typography>
          </Box>
        </Paper>
      )
    )}
  </Box>
</Paper> */}

          {/* Team Members */}

          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              height: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 3,
              }}
            >
              <GroupsIcon color="primary" />

              <Typography variant="h6" fontWeight={600}>
                Team Members
              </Typography>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "repeat(2,1fr)",
                  lg: "repeat(3,1fr)",
                },
                gap: 2,
              }}
            >
              {[
                {
                  name: project.teamLeadName,
                  reg: project.reg_no,
                  dept: project.dept,
                  number: project.number,
                  leader: true,
                },
                {
                  name: project.member1Name,
                  reg: project.member1Reg_no,
                  dept: project.member1Dept,
                  number: project.member1Number,
                },
                {
                  name: project.member2Name,
                  reg: project.member2Reg_no,
                  dept: project.member2Dept,
                  number: project.member2Number,
                },
                {
                  name: project.member3Name,
                  reg: project.member3Reg_no,
                  dept: project.member3Dept,
                  number: project.member3Number,
                },
              ]
                .filter((member) => member.name)
                .map((member, index) => (
                  <Paper
                    key={index}
                    elevation={0}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1.5,
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "primary.main",
                          }}
                        >
                          {member.name[0]}
                        </Avatar>

                        <Box>
                          <Typography fontWeight={600}>
                            {member.name}
                          </Typography>

                          {member.leader && (
                            <Typography variant="caption" color="primary">
                              Team Leader
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      {profile.role === "admin" && (
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() =>
                            confirmDeleteMember(project.teamId, member.reg)
                          }
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      )}
                    </Box>

                    <Box sx={{ mt: 1 }}>
                      <Chip
                        label={member.dept}
                        size="small"
                        color="primary"
                        sx={{ mb: 1 }}
                      />

                      <Typography
                        variant="caption"
                        display="block"
                        color="text.secondary"
                      >
                        Reg No: {member.reg}
                      </Typography>

                      <Typography
                        variant="caption"
                        display="block"
                        color="text.secondary"
                      >
                        Phone: {member.number}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
            </Box>
          </Paper>
        </Grid>
        {/* Mentor Details */}

        <Grid item xs={12} md={4} lg={3} p={3}>
          {" "}
          <Paper
            sx={{
              p: 3,
              width: "100%",
              boxSizing: "border-box",
              position: "sticky",
              top: 20,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 3,
              }}
            >
              <SchoolIcon color="primary" />

              <Typography fontWeight={600} fontSize="1rem">
                Mentor Details
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  fontSize: "1.2rem",
                  mb: 2,
                  bgcolor: "primary.main",
                }}
              >
                <PersonIcon />
              </Avatar>

              <Typography variant="h6" fontWeight={600}>
                {project.mentor || "Not Assigned"}
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Mentor
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <EmailIcon fontSize="small" />
                  <Typography variant="body2">mentor@college.edu</Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <PhoneIcon fontSize="small" />
                  <Typography variant="body2">+91 9876543210</Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default ProjectDetails;
